export default {
  logout: '/logout',
  mobileLogout: '/logout?redirect_url=http://localhost:3001',
};
